"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ModalConstructor_1 = __importDefault(require("../../../../shared/components/ModalConstructor"));
const FaqsAnswerModal = (props) => {
    const { faq, isOpen, setIsOpen, setFaq } = props;
    if (faq == null)
        return null;
    // @ts-ignore
    return (react_1.default.createElement(ModalConstructor_1.default, { closeable: true, closeAction: true, size: "xl", title: faq === null || faq === void 0 ? void 0 : faq.titulo, open: isOpen, setOpen: setIsOpen },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: faq.conteudo } })));
};
exports.default = FaqsAnswerModal;
